/* eslint-disable react/prop-types */

import React, { useState } from "react";
import tw, { css } from "twin.macro";
import { PortableText as BlockContent } from "@portabletext/react";

import * as T from "~components/styles/Typography.jsx";
import Go from "~components/Go.jsx";

const serializers = {
  block: {
    h1: ({ children }) => (
      <T.Head level="1" font="1">
        {children}
      </T.Head>
    ),
    h2: ({ children }) => (
      <T.Head level="2" font="2">
        {children}
      </T.Head>
    ),
    h3: ({ children }) => (
      <T.Head level="3" font="3">
        {children}
      </T.Head>
    ),
    h4: ({ children }) => (
      <T.Head level="4" font="4">
        {children}
      </T.Head>
    ),
    h5: ({ children }) => (
      <T.Head level="5" font="5">
        {children}
      </T.Head>
    ),
    b1: ({ children }) => <T.Body font="1">{children}</T.Body>,
    body2: ({ children }) => <T.Body font="2">{children}</T.Body>,
    b2: ({ children }) => <T.Body font="2">{children}</T.Body>,
    b3: ({ children }) => <T.Body font="3">{children}</T.Body>,
    caption: ({ children }) => <T.Caption node="p">{children}</T.Caption>,
    normal: ({ children }) => <T.Body font="1">{children}</T.Body>
  },
  marks: {
    strong: ({ children }) => <strong>{children}</strong>,
    em: ({ children }) => <em>{children}</em>,
    sup: ({ children }) => <sup>{children}</sup>,
    sub: ({ children }) => <sub>{children}</sub>,
    link: ({ children, value }) => {
      return (
        <Go to={value?.href} _css={[tw`underline`]} newTab>
          {children}
        </Go>
      );
    }
  },
  list: {
    bullet: ({ children }) => <ul tw="ml-[2ch] list-disc">{children}</ul>,
    number: ({ children }) => <ol tw="ml-[2ch] list-decimal">{children}</ol>
  },
  listItem: (props) => (
    <li tw="mb-1">
      <T.Body font="1">{props.children}</T.Body>
    </li>
  )
};

const PortableText = ({ blocks, serializer, _css }) => {
  //

  if (!blocks) {
    console.error(`Portable Text: Blocks is undefined`);
    return null;
  }

  return (
    <div css={[_css]}>
      <BlockContent
        value={blocks}
        components={serializer || serializers}
        css={[
          css`
            & > * {
              margin-bottom: 1rem;
            }

            & > *:last-child {
              margin-bottom: 0;
            }
          `
        ]}
      />
    </div>
  );
};

export default PortableText;
